

















































































































































































































import Modal from "../../core/Modals/Modal.vue";
import { AvisDeVirementApi } from "../../api/AvisDeVirementApi";
import { DateUtils } from "../../utils/DateUtils";

export default {
    name: "ReleveBancaireImportModal",
    components: { Modal },
    props: {
        showModal: Boolean,
    },
    data() {
        return {
            AvisDeVirementApi: new AvisDeVirementApi(),
            file: null,
            importing: false,
            report: null,
            error: null,
        };
    },
    methods: {
        handleFileUpload(event): void {
            this.file = event.target.files[0];
            this.error = null;
        },
        importReleve(): void {
            let self = this;

            if (self.importing) {
                return;
            }
            if (!self.file) {
                self.error = "Veuillez sélectionner un fichier";
                return;
            }

            self.importing = true;
            self.error = null;
            self.report = null;

            self.AvisDeVirementApi.importReleve(self.file)
                .then(function (response) {
                    self.importing = false;
                    self.report = response.data;
                    // La liste est rafraîchie tout de suite, le rapport reste
                    // affiché tant que l'utilisateur ne ferme pas la modale.
                    self.$emit("imported", response.data);
                })
                .catch(function (error) {
                    self.importing = false;
                    self.error =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        "L'import du relevé a échoué";
                });
        },
        closeModal(): void {
            this.$emit("close-modal");
        },
        // UI
        dateStr(date): string {
            return date ? DateUtils.sqlToDateStr(date, "DD/MM/YYYY") : "";
        },
        hasRows(rows): boolean {
            return !!rows && rows.length > 0;
        },
        roundAmount(amount) {
            return _.round(amount || 0, 2).toFixed(2);
        },
    },
    watch: {
        showModal(newVal) {
            if (newVal) {
                // Réinitialisation à chaque ouverture.
                this.file = null;
                this.report = null;
                this.error = null;
                if (this.$refs.fileInput) {
                    this.$refs.fileInput.value = "";
                }
            }
        },
    },
};
